import { atom } from "recoil";

export const groupStore = atom({
	key: "groupStore",
	default: {
		loaded: false,
		data: [],
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
		currentOption: {
			type: [{ value: "id", label: "id" }, { value: "name", label: "name" }],
		},
		currentSearch: "",
		currentSearchType: { value: "id", label: "id" },
		sorting: {
			sortingColumn: {
				order: "DESC",
				column: "id",
			},
			isDescending: true,
		},
		pagination: {
			current: 1,
			total: 0,
			count: 0,
		},
	},
});
